/**
 * Get a specific field value coming from the database.
 */
export const getField = (name, defaultValue = "") => {
  return window.PolluxQuiz.data.fields[name]
    ? window.PolluxQuiz.data.fields[name]
    : defaultValue;
};

/**
 * Seialize form data.
 */
export const serializeForm = (data) => {
  let obj = {};
  for (let [key, value] of data) {
    if (obj[key] !== undefined) {
      if (!Array.isArray(obj[key])) {
        obj[key] = [obj[key]];
      }
      obj[key].push(value);
    } else {
      obj[key] = value;
    }
  }
  return obj;
};
